import { customAlphabet } from "nanoid";

const ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
const randomPart = customAlphabet(ALPHABET, 16);

/**
 * A framework nanoid whose 8-char base36 timestamp prefix is `timestampMs` rather than
 * now. Ids sort by that prefix, so an import or a backfill that regenerates ids passes the
 * row's own `createdAt` here to keep its creation order. Negative or fractional input
 * clamps to a whole, non-negative millisecond.
 */
export function nanoidAt(timestampMs: number): string {
  const ms = Math.max(0, Math.floor(timestampMs));
  return ms.toString(36).padStart(8, "0") + randomPart();
}

export function nanoid(): string {
  return nanoidAt(Date.now());
}

/** The exact shape {@link nanoid} produces: 24 characters of {@link ALPHABET}. */
const NANOID_SHAPE = /^[0-9a-z]{24}$/;

/**
 * Whether a string has the exact shape of a framework nanoid (8-char base36
 * timestamp + 16 random base36 chars). Shape only — it says nothing about
 * whether a row with that id exists.
 */
export function isNanoid(value: string): boolean {
  return NANOID_SHAPE.test(value);
}
